import { useEffect } from "react";

export function useVisibleRefresh(refresh: () => Promise<void>, cancel: () => void, active = true) {
  useEffect(() => {
    if (!active) return;
    const update = () => {
      if (document.visibilityState === "visible") void refresh();
      else cancel();
    };
    update();
    const timer = window.setInterval(update, 60_000);
    document.addEventListener("visibilitychange", update);
    return () => {
      window.clearInterval(timer);
      document.removeEventListener("visibilitychange", update);
      cancel();
    };
  }, [refresh, cancel, active]);
}
